import { useTranslate } from "@refinedev/core";
import { useMediaAssetsStorage } from "hooks/useMediaAssetsStorage/";
import { MediaAsset, MediaProjectResponse } from "pages/media/types/";
import { useNavigate } from "react-router-dom";
import { StyledListWrapper } from "../styles";
import { Button, Empty, Flex, List, Typography } from "antd";
import { HandTapIcon } from "@phosphor-icons/react";
import { PlusOutlined } from "@ant-design/icons";
import { radius } from "@libertify/ui";

const CALL_TO_ACTIONS_PAGE_SIZE = 10;
export function ProjectSettingsFormCallToActions<T>(
  props: Readonly<{
    value: T | undefined;
    onChange: (value: T) => void;
    project?: MediaProjectResponse;
  }>
) {
  const {
    organizationAssets: { data, isLoading },
  } = useMediaAssetsStorage({
    organizationId: props.project?.organization_id,
    assetType: "CallToActions",
    enabled: Boolean(props.project?.organization_id),
    pageSize: CALL_TO_ACTIONS_PAGE_SIZE,
    autoFetchAll: true,
  });
  const navigate = useNavigate();
  const t = useTranslate();

  const handleButtonClick = () => {
    navigate(`/media/ctas/create?project_id=${props.project?.id}`);
  };
  return (
    <StyledListWrapper>
      <List<MediaAsset>
        split={false}
        size="small"
        loading={isLoading}
        dataSource={data?.data || []}
        pagination={{
          pageSize: CALL_TO_ACTIONS_PAGE_SIZE,
        }}
        locale={{
          emptyText: (
            <Typography style={{ lineHeight: 1 }}>
              <Flex align="center" justify="center">
                <Empty image={<HandTapIcon size={100} />}>
                  <Button
                    type="primary"
                    size="middle"
                    icon={<PlusOutlined />}
                    shape="round"
                    onClick={handleButtonClick}
                  >
                    {t("projects.components.ProjectSettings.createCta")}
                  </Button>
                </Empty>
              </Flex>
            </Typography>
          ),
        }}
        renderItem={(item) => (
          <List.Item
            key={item.id}
            onClick={() => props?.onChange(item.id as T)}
            className={props.value === item.id ? "active" : ""}
            style={{
              borderRadius: radius.box,
              marginBottom: 10,
              paddingLeft: 10,
            }}
          >
            {item.description || item.id}
          </List.Item>
        )}
      />
    </StyledListWrapper>
  );
}
